/*!
Copyright (C) 2020 Liberty Infrasystems LLC. All rights reserved.
*/

/* eslint-disable no-console */

const SECOND = 1000; // milliseconds
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const YEAR = DAY * 365;

// returns the interval in milliseconds
function toMillis(descriptor) {
    const {
        years = 0,
        days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0,
        milliseconds = 0,
    } = descriptor;
    return (years * YEAR) + (days * DAY) + (hours * HOUR) + (minutes * MINUTE) + (seconds * SECOND) + milliseconds;
}

// returns the interval in seconds
// if the interval includes non-zero milliseconds, answer will be rounded down to make an integer seconds
function toSeconds(descriptor) {
    return Math.floor(toMillis(descriptor) / 1000);
}

// TODO: there should also be a toText(descriptor) function;  but we have to leave this one the way it is so we don't break existing code
function toText(millis) {
    if (typeof millis !== 'number') {
        throw new Error('not a number');
    }
    if (millis === 0) {
        return 'no time';
    }
    const display = [];
    let remainder = millis;
    if (millis < 0) {
        display.push('negative');
        remainder = Math.abs(millis);
    }
    if (remainder >= YEAR) {
        const years = Math.floor(remainder / YEAR);
        remainder %= YEAR;
        const text = years > 1 ? 'years' : 'year';
        display.push(`${years} ${text}`);
    }
    if (remainder >= DAY) {
        const days = Math.floor(remainder / DAY);
        remainder %= DAY;
        const text = days > 1 ? 'days' : 'day';
        display.push(`${days} ${text}`);
    }
    if (remainder >= HOUR) {
        const hours = Math.floor(remainder / HOUR);
        remainder %= HOUR;
        const text = hours > 1 ? 'hours' : 'hour';
        display.push(`${hours} ${text}`);
    }
    if (remainder >= MINUTE) {
        const minutes = Math.floor(remainder / MINUTE);
        remainder %= MINUTE;
        const text = minutes > 1 ? 'minutes' : 'minute';
        display.push(`${minutes} ${text}`);
    }
    if (remainder >= SECOND) {
        const seconds = Math.floor(remainder / SECOND);
        remainder %= SECOND;
        const text = seconds > 1 ? 'seconds' : 'second';
        display.push(`${seconds} ${text}`);
    }
    if (remainder >= 1) {
        const text = 'ms';
        const milliseconds = Math.floor(remainder);
        display.push(`${milliseconds} ${text}`);
    }
    return display.join(' ');
}

export { toMillis, toSeconds, toText };
